import angular from 'angular';

(function() {
    'use strict';

    var kissMultiSelect = {
        controller: 'MultiSelectCtrl as vm', // Possibilité d'utiliser 'MultiSelectCtrl as vm'. Si on ne met rien
        // le controlleur est bindé avec $ctrl
        templateUrl: require('./multi-select.html'),
        bindings: {
            availableLabel: '@',
            availableList: '=',
            selectedLabel: '@',
            selectedList: '='
        }
    };

    angular.module('app.widgets').component('kissMultiSelect', kissMultiSelect);
})();
